import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Switch } from "antd";
import URI from "urijs";
import { FormattedMessage } from "react-intl";

const ReadUnreadToggle = props => {
  const {
    handleGetDocumentsWithSearch
  } = props;
  const currentLink = useSelector(state => state.documentsWithSearch.currentLink);
  const list = useSelector(state => state.documentsWithSearch.results.list);
  const isGettingDocumentsWithSearch = useSelector(state => state.documentsWithSearch.isGettingDocumentsWithSearch);

  const [onlyUnRead, setOnlyUnRead] = useState(false);

  useEffect(() => {
    if (isGettingDocumentsWithSearch || !currentLink) return;
    let updateUrl = new URI(currentLink);
    let currentValSwitch = updateUrl.search(true)["onlyUnread"];
    setOnlyUnRead(currentValSwitch === "true");
  }, [currentLink]);

  const toggleSwitch = checked => {
    let updateUrl = new URI(currentLink);
    updateUrl.setSearch({ onlyUnread: checked });

    if (list.length > 0)
      handleGetDocumentsWithSearch({link:`${updateUrl._parts.protocol}://${updateUrl._parts.hostname}${updateUrl._parts.path}?${updateUrl._parts.query}`});
    setOnlyUnRead(checked);
  };

  return (
    <div style={{ marginRight: "21px", marginBottom:"8px" }}>
      <label><FormattedMessage id="documents.onlyUnread" /></label>
      <Switch
        checked={onlyUnRead}
        style={{ marginLeft: "8px" }}
        onChange={checked => {
          toggleSwitch(checked);
        }}
      />
    </div>
  );
};
export default ReadUnreadToggle;
